'use strict';

var ReactUpdates = require('react/lib/ReactUpdates');

function flushUpdates(action) {
  ReactUpdates.batchedUpdates(action);
  ReactUpdates.flushBatchedUpdates();
}

module.exports = flushUpdates;


/** WEBPACK FOOTER **
 ** ./utils/flushUpdates.js
 **/